import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-support',
  imports: [MatToolbarModule, MatDividerModule, MatIconModule],
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
})
export class SupportComponent implements OnInit {
  hasHistory: boolean = false;

  constructor(private location: Location, private router: Router) {
  }

  ngOnInit(): void {
    this.hasHistory = window.history.length > 1;
  }

  back() {
    if (this.hasHistory) {
      this.location.back();
    } else {
      this.router.navigate(['/dashboard']);
    }
  }

}
